import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/chats",
    name: ROUTE_NAME.CHATS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.CHAT_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.CHAT_LIST,
        component: () => import("./views/ChatList.vue"),
      },
      {
        path: ":id",
        name: ROUTE_NAME.CHAT_SINGLE,
        component: () => import("./views/ChatUpdate.vue"),
      },
      {
        path: ":id/:messageid",
        name: ROUTE_NAME.CHAT_MESSAGE,
        component: () => import("./views/ChatMessage.vue"),
      },
    ],
  },
];
